var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipedgas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.531,
    height: 35.935,
    viewBox: "0 0 48.531 35.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#4f4f4f;}.b{stroke:#40b895;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.99,219.866l7.789,5.843,5.466-7.728",
    transform: "translate(-202.907 -202.088)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.697,
    y1: 9.569,
    transform: "translate(26.872 23.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M124.669,250.373a10.258,10.258,0,0,0,1.168,4.765H112.42V246.49h13.008A10.254,10.254,0,0,0,124.669,250.373Z",
    transform: "translate(-108.115 -226.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M353.795,246.48v8.648H347.6a10.36,10.36,0,0,0,.409-8.648Z",
    transform: "translate(-311.576 -226.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M397.242,225.01h-3.132a.592.592,0,0,1-.591-.591V205.841a.592.592,0,0,1,.591-.591h3.132a.592.592,0,0,1,.591.591v18.58A.592.592,0,0,1,397.242,225.01Z",
    transform: "translate(-351.302 -191.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.222,225.01H81.091a.592.592,0,0,1-.591-.591V205.841a.592.592,0,0,1,.591-.591h3.132a.592.592,0,0,1,.591.591v18.58A.594.594,0,0,1,84.222,225.01Z",
    transform: "translate(-80.5 -191.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M223.883,209.124a10.3,10.3,0,1,1-.754-3.883A10.271,10.271,0,0,1,223.883,209.124Z",
    transform: "translate(-186.695 -185.503)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 5.47,
    cy: 5.47,
    rx: 5.47,
    ry: 5.47,
    transform: "translate(8.142 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 3.385,
    y1: 4.362,
    transform: "translate(16.974 10.476)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedgas);
export default __webpack_public_path__ + "static/media/pipedgas.b0e133c69c13388ddd7f6cf83b0290b2.svg";
export { ForwardRef as ReactComponent };